import { connect } from 'react-redux';
import ArticleList from '../articleList';
import getCitedByProcessor from '../../../utils/citedBy/getCitedByProcessor';
import createArticleEvents from '../../../utils/trackers/createArticleEvents';

const mapStateToProps = (state) => {
  const { citingArticles, idType } = state;
  const processor = getCitedByProcessor(idType);
  const articleListItemViewPropsArray = processor
    ? processor.createArticleListProps(citingArticles)
    : [];

  const articles = articleListItemViewPropsArray.map((article) => {
    const { documentSubtype, pii, doi } = article;

    const eventDataProps = createArticleEvents(
      'citedby-panel',
      { documentSubtype },
      { pii, doi },
    );

    return ({
      ...article,
      eventData: eventDataProps,
    });
  });

  return { articles };
};

export default connect(mapStateToProps)(ArticleList);
